module.exports = __webpack_public_path__ + "static/icons-nocolor-6faa23bdd6770d83b754bb6762801129.svg";